import { Component, Input } from '@angular/core';

import { Post } from '../../interfaces';
import { Router } from '@angular/router';

@Component({
  selector: 'edge-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent {
  @Input() newsArticle: Post;
  @Input() previousNextArticles: Array<Post>;

  soccerIcon = '/assets/images/icon-soccer.svg';
  footballIcon = '/assets/images/icon-football.svg';
  generalIcon = '/assets/images/icon-general.svg';
  exerciseIcon = '/assets/images/icon-exercise.svg';
  profileIcon = '/assets/images/profile.svg';

  constructor(private router: Router) {}

  getArticleCategoryIcon(article: Post): string {
    if (article.categories.indexOf('football') >= 0) {
      return this.footballIcon;
    } else if (article.categories.indexOf('soccer') >= 0) {
      return this.soccerIcon;
    } else if (article.categories.indexOf('strength and conditioning') >= 0) {
      return this.exerciseIcon;
    } else {
      return this.generalIcon;
    }
  }

  /**
   * Gets the full url to the current article
   * @returns The current article url
   */
  getUrl(): string {
    return 'https://www.goarmyedge.com' + this.router.url;
  }
}
